import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { BASE_URL, GET_STATEMENT, GET_STATEMENT_DETAIL, M_POST, STATEMENT_SHEET } from '@/utils/api';

@Module({ name: 'statement' })
export default class Statement extends VuexModule {
  dataStatement: any = [];

  dataStatementDetail: any = [];

  @Mutation
  mutateStatement(statement: any) {
    this.dataStatement = statement?.data;
  }

  @Mutation
  mutateStatementDetail(statementDetail: any) {
    this.dataStatementDetail = statementDetail;
  }

  @Action({ commit: 'mutateStatement', rawError: true })
  async FetchStatement(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + GET_STATEMENT,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch statement failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch statement failed');
    }
  }

  @Action({ commit: 'mutateStatementDetail', rawError: true })
  async FetchStatementDetail(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + GET_STATEMENT_DETAIL,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch statement detail failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch statement detail failed');
    }
  }

  @Action
  async StatementDownloadSheet(params: Record<string, any> = {}) {
    try {
      const resp = await axios({
        url: BASE_URL + STATEMENT_SHEET,
        data: params,
        method: M_POST,
        responseType: 'blob'
      } as any);

      const blob = resp?.data as Blob;

      const contentType = String(resp?.headers?.['content-type'] ?? '').toLowerCase();
      if (contentType.includes('application/json')) {
        const text = await blob.text();
        let msg = 'Export failed';
        try {
          const json = JSON.parse(text);
          msg = json?.status?.message || json?.message || json?.msg || msg;
          throw toError({ response: { data: json } }, msg);
        } catch (_e) {
          throw toError({ response: { data: { message: msg } } }, msg);
        }
      }

      return blob;
    } catch (err) {
      throw toError(err, 'Export failed');
    }
  }
}
